<template>
    <div id="locationSearchBar">
        <gmap-autocomplete
            class="locationSearch smallText"
            placeholder="Enter Your Location"
            :value="tempAddress"
            @input="tempAddress = $event.target.value"
            @place_changed="setPlace"
        ></gmap-autocomplete>
    </div>
</template>

<script>
    export default {
        name: "LocationSearchBar",
        data(){
            return{
                tempAddress: null
            }
        },
        methods: {
            setPlace(e) {
                this.$store.state.businesses.mapSettings.center = this.$store.state.businesses.mapSettings.position = {
                    lat: e.geometry.location.lat(),
                    lng: e.geometry.location.lng(),
                }
            }
        }
    }
</script>
